<template>
  <span class="def-arrow-down">
    <svg
      class="def-arrow-down__icon"
      :class="{ 'def-arrow-down__icon_active': active }"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.44398 7.80244C4.77187 7.47455 5.30348 7.47455 5.63137 7.80244L10.0754 12.2464L14.5194 7.80244C14.8472 7.47455 15.3789 7.47455 15.7067 7.80244C16.0346 8.13033 16.0346 8.66194 15.7067 8.98983L10.6691 14.0275C10.3412 14.3554 9.80955 14.3554 9.48166 14.0275L4.44398 8.98983C4.11609 8.66194 4.11609 8.13033 4.44398 7.80244Z"
        fill="#5F5F67"
      />
    </svg>
  </span>
</template>

<script lang="ts" setup>
const props = defineProps<{ active: boolean }>();
</script>

<style lang="scss" scoped>
.def-arrow-down {
  cursor: pointer;
  &__icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    transition: 0.2s linear transform;
    &_active {
      transform: rotate(180deg);
    }
  }
}
</style>
